import { NovaCmsApp } from "./cms/NovaCmsApp";
import { NovaExperience } from "./experience/NovaExperience";
import { NovaQrMenu } from "./menu/NovaQrMenu";
import { NovaPosShell } from "./pos/NovaPosShell";
import { NovaServiceEnquiryPage } from "./operations/NovaServiceEnquiryPage";
import { NovaFeedbackPage } from "./operations/NovaFeedbackPage";

function normalizePathname(
  pathname: string,
) {
  if (
    pathname.length > 1 &&
    pathname.endsWith("/")
  ) {
    return pathname.slice(
      0,
      -1,
    );
  }

  return pathname;
}

export function App() {
  const pathname =
    normalizePathname(
      window.location.pathname,
    );

  const searchParams =
    new URLSearchParams(
      window.location.search,
    );

  const tableNumber =
    searchParams
      .get("t")
      ?.trim();

  const isPrivateOperationalRoute =
    pathname === "/pos" ||
    pathname.startsWith("/pos/") ||
    pathname === "/nova-hq" ||
    pathname.startsWith("/nova-hq/");

  let robotsMeta =
    document.querySelector<HTMLMetaElement>(
      'meta[name="robots"]',
    );

  if (!robotsMeta) {
    robotsMeta =
      document.createElement("meta");

    robotsMeta.name = "robots";
    document.head.appendChild(
      robotsMeta,
    );
  }

  robotsMeta.content =
    isPrivateOperationalRoute
      ? "noindex, nofollow, noarchive"
      : "index, follow, max-image-preview:large";

  if (
    pathname === "/pos" ||
    pathname.startsWith("/pos/")
  ) {
    document.title =
      "Nova POS";
  } else if (
    pathname === "/menu"
  ) {
    document.title =
      tableNumber
        ? `Table ${tableNumber} · Nova Menu`
        : "Nova Menu";
  } else if (
    pathname === "/nova-hq" ||
    pathname.startsWith("/nova-hq/")
  ) {
    document.title =
      "Nova HQ";
  } else if (
    pathname === "/enquire"
  ) {
    document.title =
      "Enquire · Nova Res Culina";
  } else if (
    pathname === "/feedback"
  ) {
    document.title =
      "Feedback · Nova Res Culina";
  } else {
    document.title =
      "Nova Res Culina";
  }


  if (
    pathname === "/nova-hq" ||
    pathname.startsWith("/nova-hq/")
  ) {
    return <NovaCmsApp />;
  }

  if (pathname === "/menu") {
    return <NovaQrMenu />;
  }

  if (pathname === "/enquire") {
    return <NovaServiceEnquiryPage />;
  }

  if (pathname === "/feedback") {
    return <NovaFeedbackPage />;
  }

  if (
    pathname === "/pos" ||
    pathname.startsWith("/pos/")
  ) {
    return <NovaPosShell />;
  }

  return <NovaExperience />;
}
